import React, { memo, useState, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import webchat from '../../../../assets/images/webchat_icon.svg';
import messenger from '../../../../assets/images/messenger_icon.svg';
import whatsapp from '../../../../assets/images/whatsapp_icon.svg';
import instagram from '../../../../assets/images/instagram_icon.svg';
import { CompanyActions } from '../../../../store/actions/companies';
import { PlanActions } from '../../../../store/actions/plans';

import '../Plan.css';

function ModalCreatePackageAdd(props) {
  const { company, user, createAdditionalMessage } = props;

  const [groupChannel, setGroupChannel] = useState(
    company?.plan?.franchise || []
  );

  const [checkValidation, setCheckValidation] = useState([]);
  const [addMessage, setAddMessage] = useState();
  const [isSave, setIsSave] = useState(false);

  useEffect(() => {
    setGroupChannel(company?.plan?.franchise || []);
  }, [company]);

  useEffect(() => {
    if (isSave) {
      const payload = {
        companyId: company._id,
        responsible: user._id,
        channels: checkValidation[0].channels,
        additionalMessage: addMessage,
      };
      createAdditionalMessage(payload);
      closeModal();
      setIsSave(false);
    }
  }, [isSave]);

  const channelsIcon = (channel) => {
    const channels = {
      webchat,
      messenger,
      whatsapp,
      instagram,
    };
    return channels[channel];
  };

  const isCheckValidation = (plan, index) => {
    setCheckValidation([plan]);
  };

  const savePackage = () => {
    if (checkValidation.length > 0 && addMessage > 0) {
      for (let i = 0; i < checkValidation.length; ++i) {
        checkValidation[i].additionalMessage = addMessage;
        setCheckValidation(checkValidation);
      }
      setIsSave(true);
    } else {
      setIsSave(false);
    }
  };

  const closeModal = () => {
    $('#createPackageAdd').modal('hide');
  };
  return (
    <div className="modal-mensagens">
      <div className="title-modal-mensagens">
        Novo pacote adicional
        <span onClick={closeModal}>X</span>
      </div>
      <div className="container-input-modal-mensagens">
        <p className="subtitle-modal-mensagens">
          Quantidade de Mensagens - Pacote adicional
        </p>
        <input
          name="amountMessage"
          value={addMessage}
          placeholder="Quantidade"
          type="number"
          onChange={(e) => setAddMessage(e.target.value)}
        />
      </div>
      <div className="container-group-channel-add">
        Grupo de canais:
        <div>
          {groupChannel?.map((plan, index) => (
            <div
              className="container-img-channels-modal-create"
              key={plan?._id}
            >
              <input
                type="radio"
                checked={checkValidation.some((element) => element === plan)}
                onClick={() => isCheckValidation(plan, index)}
              />
              {plan?.channels?.map((channel) => (
                <div key={channel}>
                  <img src={channelsIcon(channel)} />
                  <span>{channel}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="container-button-contratar">
        <button onClick={savePackage}>salvar</button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  company: state.companies.company,
  user: state.users.signedUser,
  companyMessagesPerBot: state.reports.companyMessagesPerBot,
  plans: state.plans.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...CompanyActions,
      ...PlanActions,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(ModalCreatePackageAdd))
);
